export enum ReceivingDisposition {
  Consolidation = "consolidation",
  Liquidation = "liquidation",
}
